import * as yup from 'yup'

const AddInvoiceItemsSchema = yup.object().shape({
    invoice_item_name: yup.string().required(),
    invoice_item_amount: yup.number().required(),
})

export default AddInvoiceItemsSchema
